"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const aws_iot_device_sdk_1 = require("aws-iot-device-sdk");
const uuid_1 = require("uuid");
const index_1 = require("./index");
const Log_1 = __importDefault(require("../Log"));
const IotStatus_1 = require("./IotStatus");
class Messaging {
    constructor(agentId, environmentId, credentials) {
        this.broadcastHandlers = [];
        this.privateHandlers = [];
        this.handleIncomingMessage = (topic, data) => {
            if (topic === this._topics[index_1.MessageTypes.PRIVATE]) {
                this.privateHandlers.forEach((item) => item(data));
            }
            else {
                this.broadcastHandlers.forEach((item) => item(data));
            }
        };
        this.unsubscribeAll = () => {
            this.privateHandlers = [];
            this.broadcastHandlers = [];
            if (this._subscribed[index_1.MessageTypes.PRIVATE]) {
                this._device.unsubscribe(this._topics[index_1.MessageTypes.PRIVATE]);
                this._subscribed[index_1.MessageTypes.PRIVATE] = false;
            }
            if (this._subscribed[index_1.MessageTypes.BROADCAST]) {
                this._device.unsubscribe(this._topics[index_1.MessageTypes.BROADCAST]);
                this._subscribed[index_1.MessageTypes.BROADCAST] = false;
            }
        };
        this._agentId = agentId;
        this._environmentId = environmentId;
        this._topics = {
            [index_1.MessageTypes.BROADCAST]: environmentId + '/messaging',
            [index_1.MessageTypes.PRIVATE]: environmentId + '/messaging/' + agentId
        };
        this._subscribed = {
            [index_1.MessageTypes.BROADCAST]: false,
            [index_1.MessageTypes.PRIVATE]: false
        };
        this._region = credentials.region;
        this._host = credentials.messagingEndpoint;
        this._credentials = credentials;
    }
    onConnection(connectionHandler) {
        this._connectionHandler = connectionHandler;
    }
    connect() {
        Log_1.default.debug('Initializing Messaging device...');
        this._device = new aws_iot_device_sdk_1.device({
            region: this._region,
            host: this._host,
            clientId: `${this._agentId}@${this._environmentId}`,
            protocol: 'wss',
            accessKeyId: this._credentials.accessKeyId,
            secretKey: this._credentials.secretAccessKey,
            sessionToken: this._credentials.sessionToken,
            keepalive: 30
        });
        this._webSocketExpireTime = this._credentials.expireTime;
        this._device.on('message', (topic, data) => {
            try {
                this.handleIncomingMessage(topic, JSON.parse(data));
            }
            catch (err) {
                Log_1.default.error(`Failed to parse incoming message: ${err}`);
            }
        });
        this._device.on('connect', () => {
            var _a;
            Log_1.default.debug('Messaging service connected');
            (_a = this._connectionHandler) === null || _a === void 0 ? void 0 : _a.call(this, IotStatus_1.IotStatus.CONNECTED);
        });
        this._device.on('reconnect', () => {
            var _a;
            Log_1.default.debug('Messaging reconnecting');
            (_a = this._connectionHandler) === null || _a === void 0 ? void 0 : _a.call(this, IotStatus_1.IotStatus.RECONNECTING);
        });
        this._device.on('close', () => {
            var _a;
            Log_1.default.debug('Messaging connection closed');
            (_a = this._connectionHandler) === null || _a === void 0 ? void 0 : _a.call(this, IotStatus_1.IotStatus.CLOSED);
        });
        this._device.on('offline', () => {
            var _a;
            Log_1.default.error('Messaging service offline');
            (_a = this._connectionHandler) === null || _a === void 0 ? void 0 : _a.call(this, IotStatus_1.IotStatus.OFFLINE);
        });
        this._device.on('error', (error) => {
            var _a;
            if (error) {
                if (error instanceof Error) {
                    Log_1.default.error(`Messaging error occurred: ${error.name} - ${error.message}`);
                }
                else {
                    Log_1.default.error(`Messaging error occurred: ${error}`);
                }
                (_a = this._connectionHandler) === null || _a === void 0 ? void 0 : _a.call(this, IotStatus_1.IotStatus.ERROR);
            }
        });
        this.handleCredentialsRefresh();
    }
    sendMessage(type, payload, remoteAgent) {
        if (!this._device) {
            throw Error('Messaging device not connected');
        }
        let topic = this._topics[index_1.MessageTypes.BROADCAST];
        if (remoteAgent) {
            topic += '/' + remoteAgent.id;
        }
        const data = {
            messageId: uuid_1.v4(),
            senderId: this._agentId,
            timestamp: new Date().toISOString(),
            type,
            payload
        };
        this._device.publish(topic, JSON.stringify(data));
    }
    subscribeToMessages(type, handlers) {
        if (!type) {
            type = index_1.MessageTypes.ALL;
        }
        Log_1.default.debug(`Subscribing to messages of type ${type}`);
        if (handlers) {
            if (handlers.privateMessage) {
                this.privateHandlers.push(handlers.privateMessage);
            }
            if (handlers.broadcastMessage) {
                this.broadcastHandlers.push(handlers.broadcastMessage);
            }
        }
        if (type === index_1.MessageTypes.ALL || type === index_1.MessageTypes.BROADCAST) {
            if (!this._subscribed[index_1.MessageTypes.BROADCAST]) {
                this._device.subscribe(this._topics[index_1.MessageTypes.BROADCAST]);
                this._subscribed[index_1.MessageTypes.BROADCAST] = true;
            }
        }
        if (type === index_1.MessageTypes.ALL || type === index_1.MessageTypes.PRIVATE) {
            if (!this._subscribed[index_1.MessageTypes.PRIVATE]) {
                this._device.subscribe(this._topics[index_1.MessageTypes.PRIVATE]);
                this._subscribed[index_1.MessageTypes.PRIVATE] = true;
            }
        }
    }
    unsubscribeFromMessages(handler, type) {
        if (!type) {
            type = index_1.MessageTypes.ALL;
        }
        Log_1.default.debug(`Unsubscribing to messages of type ${type}`);
        if (type === index_1.MessageTypes.ALL || type === index_1.MessageTypes.BROADCAST) {
            const index = this.broadcastHandlers.indexOf(handler);
            this.broadcastHandlers.splice(index, 1);
            if (this.broadcastHandlers.length == 0) {
                this._device.unsubscribe(this._topics[index_1.MessageTypes.BROADCAST]);
                this._subscribed[index_1.MessageTypes.BROADCAST] = false;
            }
        }
        if (type === index_1.MessageTypes.ALL || type === index_1.MessageTypes.PRIVATE) {
            const index = this.privateHandlers.indexOf(handler);
            this.privateHandlers.splice(index, 1);
            if (this.privateHandlers.length == 0) {
                this._device.unsubscribe(this._topics[index_1.MessageTypes.PRIVATE]);
                this._subscribed[index_1.MessageTypes.PRIVATE] = false;
            }
        }
    }
    UpdateWebsocketCredentials() {
        this._device.updateWebSocketCredentials(this._credentials.accessKeyId, this._credentials.secretAccessKey, this._credentials.sessionToken, this._credentials.expireTime);
        //Update messaging expire time so we can check properly if IoT device
        //updated credentials outside of messaging
        this._webSocketExpireTime = this._credentials.expireTime;
        //Schedule next check for credentials expiry
        setTimeout(this.handleCredentialsRefresh.bind(this), this._credentials.credentialsCheckTime);
    }
    handleCredentialsRefresh() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.debug(`Credentials will expire in: ${this._credentials.millisecondsToExpiry} ms`);
            //The expire time might be updated outside of messaging so we need to check if we need
            //to update the websocket credentials
            if (this._webSocketExpireTime !== this._credentials.expireTime) {
                this.UpdateWebsocketCredentials();
                return;
            }
            //Try to renew credentials 5 minutes before they expire
            if (this._credentials.millisecondsToExpiry > 300000) {
                //Keep checking if credentials need to be renewed every minute
                setTimeout(this.handleCredentialsRefresh.bind(this), this._credentials.credentialsCheckTime);
                return;
            }
            yield this._credentials
                .refreshPromise()
                .then(() => {
                this.UpdateWebsocketCredentials();
            })
                .catch((reason) => {
                Log_1.default.error(`Failed to refresh messaging credentials: ${reason}`);
                //Give another chance to renew credentials if they still did not expire
                if (this._credentials.millisecondsToExpiry > 1000) {
                    setTimeout(this.handleCredentialsRefresh.bind(this), 500);
                }
            });
        });
    }
    disconnect() {
        this.unsubscribeAll();
        if (!this._device) {
            throw Error('Messaging device not connected');
        }
        this._device.end();
    }
}
exports.default = Messaging;
//# sourceMappingURL=Messaging.js.map